import type { FaireProductEntity } from "../../entity_types/product";

export const p_msmv5cyjsm: FaireProductEntity = {
  token: "p_msmv5cyjsm",
  type: "product",
  name: "Jasmine Candle",
  brandToken: "b_fyb6rnmnyf",
  brandName: "Putnam Design LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/c323e8fd32541a3580e1e40a03657192b965e7410ae9f1ea06d655d066f18e2a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/117a984cac78daffff1c291ab5d60e6f25685188d4cfba511a05a11e48a80ae0.jpeg",
    "https://cdn.faire.com/fastly/da64e7118cb210c00e7931576e4d4d5c1c9e24289989c36b6b5b6b204c7bede4.jpeg",
  ],
  priceDollars: 20,
  description:
    "Single note scented candle hand-poured and crafted in Los Angeles exclusively by Putnam Design.\n\n• 9 oz of Soy wax\n• 40 hour burn time\n• Trim wick before each use",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:11.525Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
